import 'dom4'
import 'svgxuse'
import domready from 'domready'
import Hurdler from 'hurdler'
import BrowserWarning from '../browser-warning'
import InView from '../in-view'
import GlobalHeader from '../global-header'
import BlockReveal from '../block-reveal'
import Hero from '../hero'
import Map from '../map'

const hurdler = new Hurdler()

domready(() => {
  // Initialize browser warning component
  document.queryAll('[data-component="browser-warning"]').forEach(element => {
    new BrowserWarning({
      element
    })
  })
  // Initialize global header component
  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element,
      hurdler
    })
  })
  // Initialize block reveal component
  var blockReveal = new BlockReveal({
    element: document.querySelector('[data-component="block-reveal"]')
  })
  // Initialize hero component
  document.queryAll('[data-component="hero"]').forEach(element => {
    new Hero({
      element
    })
  })
  // Initialize in-view component
  document.queryAll('.in-view').forEach(element => {
    new InView({
      element,
      homeHeroReveal: () => {
        blockReveal.reputationReveal()
        blockReveal.qualityReveal()
      },
      ourClientsReveal: () => {
        blockReveal.ourReveal()
        blockReveal.clientsReveal()
        blockReveal.clientsCopyReveal()
      },
      contactReveal: () => {
        blockReveal.contactReveal()
      },
      aboutLexonReveal: () => {
        blockReveal.aboutReveal()
        blockReveal.lexonReveal()
        blockReveal.aboutLexonFirstCopyReveal()
        blockReveal.aboutLexonSecondCopyReveal()
        blockReveal.aboutLexonThirdCopyReveal()
        blockReveal.aboutLexonFourthCopyReveal()
      }
    })
  })
  // Initialize Map
  document.queryAll('[data-component="map"]').forEach((element) => {
    new Map()
  })
  hurdler.sprint()
})



// WEBPACK FOOTER //
// ./components/app/index.js